export default "__VITE_ASSET__BH$WNjEo__"